import { Injectable } from '@angular/core';
import { SerializationService } from 'aautil';
import { SendMailFormData } from '@model/customrest/send-mail-form-data';
import { RestService } from '@service/rest/rest.service';
import { ToastService } from '@service/toast/toast.service';
import { SentryService } from '@service/sentry.service';

@Injectable({
  providedIn: 'root',
})
export class PrivateMessageService {
  constructor(
    private serializationService: SerializationService,
    private restService: RestService,
    private toastService: ToastService,
    private sentryService: SentryService,
  ) {}

  public sendMail(sendMailFormData: SendMailFormData, apiModelName: string): Promise<void> {
    return new Promise((resolve, reject) => {
      // serialize
      this.serializationService
        .serialize(sendMailFormData, SendMailFormData)
        .then((data) => {
          // send
          this.restService
            .post(apiModelName + '/sendMessage', data)
            .then(() => {
              this.toastService.showSuccess('Vielen Dank für deine Nachricht.');
              resolve();
            })
            .catch((err) => {
              this.toastService.showError('Leider konnte deine Nachricht nicht versandt werden.');
              reject();
            });
        })
        .catch((err) => {
          this.sentryService.silentCaptureException(err);
          reject();
        });
    });
  }
}
